import _ from 'lodash';

import Machine from './3-Machine.jsx';
import scenesData from '../../../data/scenes.json';
import circleOfLife from '../../../flux/circleOfLife';

const scenesKeys = _.map(_.filter(scenesData, sceneData => (
    !_.get(sceneData, 'index', false)
)), sceneData => (
    sceneData.name
));

const defaultProps = {
    // slideshowKey: 'machineSlideshow',
    backgroundKey: 'kraftBackground',
    layers: [
        {
            backgroundKey: 'pipesCentered',
        },
        {
            backgroundKey: 'darkLinesBackground',
        },
    ],

    className: 'intro-lastMachine',
    sceneKeys: scenesKeys,
    fluxSettings: circleOfLife,
    animationDuration: 0.2,
    audioUrls: {
        flux: '/audio/28nov/general-liquide-mouv-01.mp3',
    },
    portraitKeys: ['agent', 'mom', 'dad', 'charles', 'lady', 'baldGuy'],

    bottomTile: true,
    bottomTileColor: 'beige',
};

class EndMachine extends Machine {

}

EndMachine.defaultProps = defaultProps;
module.exports = EndMachine;



// WEBPACK FOOTER //
// ./js/components/frames/0-Intro/5-EndMachine.jsx